import { SaveButtonStatus, Status } from '@components/Button/SaveButton';
import { FormRenderProps } from 'react-final-form';

export const getSavingStatus = <FormValues, InitialFormValues>({
  submitting,
  pristine,
  submitSucceeded,
}: FormRenderProps<FormValues, InitialFormValues>): Status => {
  if (submitting) {
    return SaveButtonStatus.SAVING;
  }
  if (submitSucceeded && pristine) {
    return SaveButtonStatus.SAVED;
  }
  return SaveButtonStatus.UNSAVED;
};
